import React from "react";
import { LOGO_URL } from "@/components/BDLogo";
import ProductImage from "@/components/ProductImage";
import { difference, products } from "@/mock";

export default function Difference() {
  return (
    <section id="about" className="bg-[#f4f4f2] py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        {/* Left: The product with the mascot logo above it */}
        <div className="relative order-2 md:order-1">
          <div className="relative aspect-[4/5] bg-[#0a0a0a] overflow-hidden flex flex-col items-center justify-center">
            {/* subtle spotlight */}
            <div
              className="absolute inset-0"
              style={{
                background:
                  "radial-gradient(55% 55% at 50% 40%, rgba(198,13,13,0.18) 0%, rgba(10,10,10,0) 65%)",
              }}
            />
            {/* Mascot logo */}
            <div className="relative z-10 pt-6 md:pt-10">
              <img
                src={LOGO_URL}
                alt="Big Dick's Undergear"
                className="h-40 md:h-56 object-contain"
              />
            </div>
            <div className="relative z-10 -mt-4 md:-mt-8 w-[70%] h-[280px] md:h-[360px] flex items-center justify-center">
              <ProductImage
                src={products[0].img}
                alt="BD boxer brief"
                className="drop-shadow-[0_30px_40px_rgba(0,0,0,0.6)]"
              />
            </div>
          </div>
          <div className="hidden md:block absolute -bottom-6 -right-6 bg-[#c60d0d] text-white px-6 py-4">
            <div className="text-[10px] tracking-[0.24em] font-bold uppercase">Since 2024</div>
            <div className="text-3xl font-black leading-none mt-1">The Club</div>
          </div>
        </div>

        {/* Right: copy */}
        <div className="order-1 md:order-2">
          <div className="text-[11px] tracking-[0.28em] text-[#c60d0d] font-bold uppercase mb-3">
            The Difference
          </div>
          <h2 className="text-4xl md:text-5xl font-black tracking-tight text-black leading-[1.02]">
            THE BIG DICK&rsquo;S
            <br />
            <span className="text-[#c60d0d]">DIFFERENCE</span>
          </h2>

          <div className="mt-8 space-y-6">
            {difference.map((d, i) => (
              <div key={d.title} className="flex gap-4 items-start group">
                <div className="shrink-0 w-14 h-14 bg-white border border-black/10 flex items-center justify-center shadow-sm overflow-hidden">
                  <img
                    src={LOGO_URL}
                    alt="BD"
                    className="w-full h-full object-cover object-top scale-[1.6]"
                  />
                </div>
                <div>
                  <div className="flex items-baseline gap-3">
                    <span className="text-[11px] text-black/40 font-bold">
                      0{i + 1}
                    </span>
                    <h3 className="text-[15px] font-black tracking-[0.08em] uppercase text-black">
                      {d.title}
                    </h3>
                  </div>
                  <p className="text-[14px] text-black/70 mt-1 leading-relaxed max-w-sm">
                    {d.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
